module.exports = __webpack_public_path__ + "static/IMG_2234-87cee29ca3ae2fcab09d5fa4340f8d36.jpg";